"use strict";

var _interopRequireDefault = require("/build-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _defineProperty2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _WorkOrderEntity = _interopRequireDefault(require("@services/WorkOrderEntity"));
var _library = require("library");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import EntityService_2 from '@services/fieldDetail'
var _default = exports.default = {
  data: function data() {
    return {
      // 上传图片
      dialogImageUrl: '',
      btnLoading: false,
      imageList: [],
      fileList: [],
      dialogVisible: false,
      uploadUtil: {},
      // 上传时候需要附带的额外参数
      uploadData: {
        is_thumb: 1
      },
      // 弹出框显示隐藏
      innerVisible: false,
      formValue: {},
      formData: {},
      form: {},
      wid: '',
      id: '',
      typeArr: [],
      configId: '',
      field: '',
      // 选择框类型
      textArr: [{
        label: this.$t('time'),
        value: 'datetime'
      }, {
        label: this.$t('dropdownSelection'),
        value: 'select'
      }, {
        label: this.$t('textInputBox'),
        value: 'text'
      }, {
        label: this.$t('textField'),
        value: 'textarea'
      }],
      options: [{
        id: 1,
        label: this.$t('low')
      }, {
        id: 2,
        label: this.$t('medium')
      }, {
        id: 3,
        label: this.$t('high')
      }, {
        id: 4,
        label: this.$t('urgent')
      }],
      json_file: []
    };
  },
  created: function created() {
    this.uploadUtil = new _library.upload({
      env: process.env.NODE_ENV,
      model: 'filer'
    });
  },
  methods: {
    open: function open(id, menuID) {
      this.id = id;
      this.configId = menuID;
      this.getInfo(this.id);
    },
    // 超出图片限制
    handleExceed: function handleExceed(files, fileList) {
      this.$message.error(this.$t('pictureLimit'));
    },
    // 上传之前判断
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJPG) {
        this.$message.error(this.$t('pictureTypeLimit'));
      }
      return isJPG;
    },
    // 图片操作
    handleRemove: function handleRemove(file, fileList) {
      this.fileList = this.fileList.filter(function (e) {
        return e !== file;
      });
      this.imageList = fileList;
    },
    // 上传成功handleSuccess
    handleSuccess: function handleSuccess(response, file, fileList) {
      file.url = file.response.data.domain + file.response.data.path;
      this.fileList.push(file);
      this.imageList = fileList;
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 获取数据的方法
    getInfo: function getInfo(id) {
      var _this = this;
      this.loading = true;
      _WorkOrderEntity.default.getWorkOrderInfo({
        id: id
      }).then(function (res) {
        var code = res.code,
          data = res.data;
        if (code === 200) {
          _this.form = _objectSpread(_objectSpread({}, data[0]), {}, {
            fieldMsg: ''
          });
          _this.fileList = eval(data[0].workorder_file || '');
          _this.imageList = _this.fileList;
          _this.getFieldAttr(data[0].workorder_type || '');
        }
      });
    },
    // 下面一个
    getFieldAttr: function () {
      var _getFieldAttr = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(type) {
        var attrTableList, field_2, formType, key, key_2;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.field = {};
              _context.prev = 1;
              _context.next = 4;
              return this.$store.dispatch('getFieldAttrList', this.configId);
            case 4:
              attrTableList = _context.sent;
              this.field = attrTableList.attrTable[type] || '';
              field_2 = this.field;
              formType = eval('(' + this.form.field_msg + ')'); // let obj = {}
              for (key in formType) {
                if (Object.hasOwnProperty.call(formType, key)) {
                  for (key_2 in field_2) {
                    if (Object.hasOwnProperty.call(field_2, key_2)) {
                      // 获取下拉框
                      if (field_2[key_2].type === 'select') {
                        field_2[key_2].values = eval(field_2[key_2].values);
                      }
                      // 赋值
                      if (key_2 == key) {
                        // obj[field_2[key_2].title] = formType[key]
                        field_2[key_2].value_two = formType[key];
                      }
                    }
                  }
                }
              }
              this.formValue = field_2;
              this.innerVisible = true;
              _context.next = 16;
              break;
            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](1);
              console.log(_context.t0);
            case 16:
              this.loading = false;
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 13]]);
      }));
      function getFieldAttr(_x) {
        return _getFieldAttr.apply(this, arguments);
      }
      return getFieldAttr;
    }(),
    // 获取角色数据类型
    // getSelect(){
    //   EntityService_2.getData().then(res=>{
    //     const { code,data,msg } = res
    //     if (code == 200) {
    //       this.typeArr = data.typeArr
    //     } else{
    //       this.$message.error(msg)
    //     }
    //   })
    // },
    // 取消
    innerCancel: function innerCancel() {
      this.innerVisible = false;
      this.formValue = {};
      this.fileList = [];
      this.imageList = [];
      this.form = {};
      this.$refs['form'].resetFields();
    },
    innerConfirm: function innerConfirm() {
      // this.submit()
      this.btnLoading = true;
      var editObj = {};
      for (var key in this.formValue) {
        if (Object.hasOwnProperty.call(this.formValue, key)) {
          editObj[key] = this.formValue[key].value_two;
        }
      }
      this.formData.urgent_status = this.form.urgent_status;
      this.formData.workorder_des = this.form.workorder_des;
      this.formData.json_file = editObj;
      this.formData.workorder_file = JSON.stringify(this.fileList);
      this.formData.image_mark = JSON.stringify(this.fileList);
      this.submit();
    },
    // /工单修改---未完成
    submit: function submit() {
      var _this2 = this;
      _WorkOrderEntity.default.markEdit(this.id, _objectSpread({}, this.formData)).then(function (res) {
        var code = res.code,
          msg = res.msg;
        if (code === 200) {
          _this2.innerCancel();
          _this2.btnLoading = false;
          _this2.$message.success(_this2.$t('editSuccess2'));
          _this2.$parent.freshList();
        } else {
          _this2.btnLoading = false;
          _this2.$message.error(msg);
        }
      }).catch();
    }
  }
};